import { makeStyles } from "@material-ui/core/styles";

export const stylesGenContract = makeStyles((theme) => ({
    form: {
        width: "100%",
        marginTop: "15px",
        marginLeft: "10px",
        marginBottom: "25px",
        paddingRight: "15px",
        paddingLeft: "15px",
        borderRadius:"8px",
    },
    inputForm: {
        backgroundColor: "#FFFFFF",
        boxSizing: "border-box",
        borderRadius: "8px",
        height: 40,
        fontSize: "14px",
        [`& fieldset`]: {
        borderRadius: 8,
        fontSize: 14,
        },
    },
    buttonContinue: {
        marginTop: "10px",
        color: "#ffffff",
        background: "#7EBDCE",
        "&:hover": { color: "white", background: "#099F9F" },
    },
    titleContractor: {
        marginLeft: "10px"
    },
    menuItem: {
        "&:hover": {
          borderLeft: "4px solid #098B8B",
        },
    },
    formControlGen: {
        marginTop: "8px"
    },
    inputDisabled: {
        backgroundColor: "#eeeeee",
        boxSizing: "border-box",
        borderRadius: "8px",
        height: 40,
        fontSize: "14px",
        [`& fieldset`]: {
        borderRadius: 8,
        fontSize: 14,
        },
    },
    formField: {
        backgroundColor: "#FFFFFF",
        boxSizing: "border-box",
        borderRadius: "8px",
        height: "40px",
        fontSize: "14px",
        [`& fieldset`]: {
          borderRadius: 8,
          fontSize: 14,
        },
        "& .MuiInputBase-root.Mui-disabled": {
          backgroundColor: "#e0e0e0",
        },
    },
    column: {
        flexBasis: "33.33%",
        marginRight: 10,
    },
    heading: {
        fontSize: theme.typography.pxToRem(12),
        wordBreak: 'normal',
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(12),
        color: theme.palette.text.secondary,
        wordBreak: 'normal'
    },
    columnEvent: {
        flexBasis: "10%",
        display: "flex",
        alignItems: "center",
        pointerEvents: 'auto'
    },
    autocompleteField: {
        backgroundColor: "#FFFFFF",
        boxSizing: "border-box",
        borderRadius: "8px",
        margin: 0,
        padding: 0,
        fontSize: "14px",
        [`& fieldset`]: {
          borderRadius: 8,
          fontSize: 14,
        },
    },
    formFieldAutocomplete: {
        backgroundColor: "#FFFFFF",
        boxSizing: "border-box",
        borderRadius: "8px",
        height: "40px",
        fontSize: "14px",
        [`& fieldset`]: {
          borderRadius: 8,
          fontSize: 14,
        },
      },
}));
